import React from "react";
/**
 * Render the toolbar with the navigation button.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export function Nav(props) {
    return React.createElement("nav", { ...props });
}
//# sourceMappingURL=Nav.js.map